export default __webpack_public_path__ + "static/media/dashboard.20b105dd.png";